var _desc, _value, _class, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

import { action, autorun, observable } from 'mobx';

import { requiredParam } from 'sdc-utilities';
import * as store from 'sdc-mobx-stores';

import { nestedMode } from 'sdc-data-models';

import { editingMode, editingType } from '..';

var UpdatingStore = (_class = function (_store$StandardStore) {
  _inherits(UpdatingStore, _store$StandardStore);

  function UpdatingStore(_ref) {
    var _ref$typeID = _ref.typeID,
        typeID = _ref$typeID === undefined ? requiredParam('typeID') : _ref$typeID,
        _ref$typesStore = _ref.typesStore,
        typesStore = _ref$typesStore === undefined ? requiredParam('typesStore') : _ref$typesStore,
        _ref$editingStore = _ref.editingStore,
        editingStore = _ref$editingStore === undefined ? requiredParam('editingStore') : _ref$editingStore,
        name = _ref.name,
        options = _objectWithoutProperties(_ref, ['typeID', 'typesStore', 'editingStore', 'name']);

    _classCallCheck(this, UpdatingStore);

    var _this = _possibleConstructorReturn(this, _store$StandardStore.call(this, options));

    _this.typeID = null;
    _this.typesStore = null;
    _this.editingStore = null;
    _this.clearViewing = true;

    _initDefineProp(_this, 'state', _descriptor, _this);

    _initDefineProp(_this, 'setState', _descriptor2, _this);

    _this.reload = function () {
      _this.list({ params: _this.state })();
    };

    _this.afterSelect = function () {
      editingType.clear();
      _this.typesStore.selectType(_this.typeID);
      _this.editingStore.updateListener = _this;
      _this.editingStore.setSelected(_this.selected);
      _this.editingStore.selectField({})();
      _this.publishEvent(_this.selected, 'selected');
      setTimeout(function () {
        editingType.setTypeID(_this.typeID);
      }, 1);
    };

    _this.afterCreate = function (entry) {
      if (nestedMode()) {
        entry.values = entry.values || {};
      }
      _this.setSelected(entry);
      _this.typesStore.selectType(_this.typeID);
      _this.editingStore.setBuffers(entry);
      _this.publishEvent(entry, 'created');
      setTimeout(function () {
        editingMode.setMode('edit');
      }, 300);
    };

    _this.updateSelected = function (entry) {
      _this.selected = entry;
      _this.dataList = store.update(_this.dataList)(_this.selected);
      _this.publishEvent(entry, 'updated');
    };

    _this.typeID = typeID;
    _this.typesStore = typesStore;
    _this.editingStore = editingStore;

    _this.name = name;

    if (name) {
      _this.editingStore.namedStores[name] = _this;
    }

    autorun(function () {
      if (_this.state.field && _this.state.linkTo) {
        _this.clearSelected();
        _this.reload();
      } else {
        _this.clearEntries();
      }
    });
    autorun(function () {
      if (editingType.typeID === _this.typeID) {
        _this.typesStore.select(_this.typeID);
        _this.editingStore.updateListener = _this;
        _this.editingStore.selectField({})();
        if (editingMode.isViewMode.get() && _this.clearViewing) {
          _this.clearSelected();
        }
      }
    });
    return _this;
  }

  return UpdatingStore;
}(store.StandardStore), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'state', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'setState', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (state) {
      if (_this2.state.field !== state.field || _this2.state.linkTo !== state.linkTo) {
        _this2.state = state;
      }
    };
  }
})), _class);
export { UpdatingStore as default };